import TextField from '@mui/material/TextField';

const FieldCustom = ({ register, label, multiline, rows }) => {
	return (
		<>
			<TextField
				id="standard-basic"
				label={label}
				variant="standard"
				multiline={multiline}
				rows={rows}
				required
				fullWidth
				{...register(label)}
			/>
		</>
	);
};

export default FieldCustom;
